import { render, staticRenderFns } from "./07GameEnds.vue?vue&type=template&id=60656916&"
import script from "./07GameEnds.vue?vue&type=script&lang=js&"
export * from "./07GameEnds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports